'use strict';

module.exports = function ($stateProvider) {
    $stateProvider
    // ENDPOINT BY TYPE
    .state('pages.main.endpoint_by_type', {
        url: '/endpoint_by_type',
        template: require('../views/system_events/endpoint_by_type.html'),
        controller: 'endpointTypeController',
        controllerAs: 'page',
        data: {
            title: 'Events By Type',
            daterange: true
        }
    })
    // ENDPOINT EVENTS USER
        .state('pages.main.endpoint_by_type_and_user', {
            url: '/endpoint_by_type_and_user',
            template: require('../views/system_events/endpoint_by_type_and_user.html'),
            controller: 'endpointTypeUserController',
            controllerAs: 'page',
            data: {
                title: 'Endpoints Triggering Event',
                subtitleElm: {
                    'Event Type': 'event_type'
                },
                daterange: true
            }
        })
    // ENDPOINT BY LOCAL IP
    .state('pages.main.endpoint_by_user', {
        url: '/endpoint_by_user',
        template: require('../views/system_events/endpoint_by_user.html'),
        controller: 'endpointUserController',
        controllerAs: 'page',
        data: {
            title: 'Events By User',
            daterange: true
        }
    })
    // ENDPOINT EVENTS LOCAL BY ALERT INFO
        .state('pages.main.endpoint_by_user_and_type', {
            url: '/endpoint_by_user_and_type',
            template: require('../views/system_events/endpoint_by_user_and_type.html'),
            controller: 'endpointUserTypeController',
            controllerAs: 'page',
            data: {
                title: 'Endpoints Triggering Event',
                subtitleElm: {
                    'Zone': 'zone',
                    'Local Hostname': 'local_hostname',
                },
                daterange: true
            }
        })
    // ENDPOINT EVENTS SHAREPOINT
    .state('pages.main.endpoint_events_sharepoint', {
        url: '/endpoint_events_sharepoint',
        template: require('../views/system_events/endpoint_events_sharepoint.html'),
        controller: 'endpointEventsSharepointController',
        controllerAs: 'page',
        data: {
            title: 'MS Events',
            daterange: true
        }
    })
    // ENDPOINT EVENTS SHAREPOINT DRILL
        .state('pages.main.endpoint_events_sharepoint_drill', {
            url: '/endpoint_events_sharepoint_drill',
            template: require('../views/system_events/endpoint_events_sharepoint_drill.html'),
            controller: 'endpointEventsSharepointDrillController',
            controllerAs: 'page',
            data: {
                title: 'MS Local Events',
                subtitleElm: {
                    'Event Type': 'event_type'
                },
                daterange: true
            }
        })
}


/** WEBPACK FOOTER **
 ** ./src/pages/routes/system_events.js
 **/